const menu = [
    {
        key: '/index',
        title: '首页',
        icon: 'home',
        auth: ['admin', 'superAdmin', 'salesman']
    },
    {
        key: '/salesData',
        title: '销售客户数据',
        icon: 'FundViewOutlined',
        auth: ['admin', 'superAdmin', 'salesman']
    },

    // {
    //     title: '其它',
    //     key: '/others',
    //     icon: 'paper-clip',
    //     auth: ['admin', 'superAdmin'],
    //     subs: [
    //         { title: '上传', key: '/others/upload', icon: '' },
    //         { title: '404', key: '/404', icon: '' },
    //         { title: '500', key: '/500', icon: '' }
    //     ]
    // },
    // {
    //     title: '多级导航',
    //     key: '/one',
    //     icon: 'bars',
    //     subs: [
    //         {
    //             title: '二级',
    //             key: '/one/two',
    //             icon: '',
    //             subs: [{ title: '三级', key: '/one/two/three', icon: '' }]
    //         }
    //     ]
    // },
    {
        title: 'Apikeys',
        key: '/apikeys',
        icon: 'DesktopOutlined',
        auth: ['admin', 'superAdmin']
    },
    {
        title: '任务小类设置',
        key: '/label',
        icon: 'ProfileOutlined',
        auth: ['admin', 'superAdmin']
    },
    {
        title: '快捷任务设置',
        key: '/quickTask',
        icon: 'ContainerOutlined',
        auth: ['admin', 'superAdmin']
    },
    {
        title: 'VIP卡设置',
        key: '/vipCard',
        icon: 'CreditCardOutlined',
        auth: ['admin', 'superAdmin']
    },
    {
        title: '积分卡设置',
        key: '/pointCard',
        icon: 'CreditCardOutlined',
        auth: ['admin', 'superAdmin']
    },
    {
        title: '模特类型',
        key: '/modelCategory',
        icon: 'AlignLeftOutlined',
        auth: ['admin', 'superAdmin']
    },
    {
        title: '模特名字',
        key: '/modelName',
        icon: 'AlignLeftOutlined',
        auth: ['admin', 'superAdmin']
    },
    {
        title: '模特图片',
        key: '/modelPicture',
        icon: 'AlignLeftOutlined',
        auth: ['admin', 'superAdmin']
    },
    {
        title: '用户等级设置',
        key: '/memberLevelConfig',
        icon: 'CrownOutlined',
        auth: ['admin', 'superAdmin']
    },
    
    
    {
        title: '用户',
        key: '/user',
        icon: 'user',
        auth: ['admin', 'superAdmin']
    },
    {
        title: '积分变化记录',
        key: '/manage/pointChangeHistory',
        icon: 'FundViewOutlined',
        auth: ['admin', 'superAdmin']
    },
    {
        title: '任务',
        key: '/task',
        icon: 'FundViewOutlined',
        auth: ['admin', 'superAdmin']
    },
    {
        title: '任务缩略图',
        key: '/task_image',
        icon: 'FundViewOutlined',
        auth: ['admin', 'superAdmin']
    },
    
    {
        title: '订单',
        key: '/order',
        icon: 'AccountBookOutlined',
        auth: ['admin', 'superAdmin']
    },
    {
        title: '支付记录',
        key: '/paymentLog',
        icon: 'PayCircleOutlined',
        auth: ['admin', 'superAdmin']
    },
    
    {
        title: '角色管理',
        key: '/role',
        icon: 'RobotOutlined',
        auth: ['admin', 'superAdmin']
    },
    {
        title: '管理员',
        key: '/admin',
        icon: 'RobotOutlined',
        auth: ['admin', 'superAdmin']
    },
    {
        title: '设置',
        key: '/setting',
        icon: 'SettingOutlined',
        auth: ['admin', 'superAdmin']
    },
]

export default menu
